module.exports = __webpack_public_path__ + "img/contribute_1.c41d8510.png";